import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { PRIMARY, QUATERNARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { ICON_POSITION } from '../../../utils/templates';
import Icon from '../../../icon/icon.component';
import { Badge } from '../../../badge/badge.component';

export const TITLES_ORDER = ['ExtraTitle', 'Title'];

export const TITLE_FONT_NAME = FONT.BERLIN_1;

export const EXTRA_TITLE_FONT_NAME = FONT.OTTAWA_3;

export const TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const DISPLAY_ICONS = true;

export const DISPLAY_TITLE = true;

export const DISPLAY_EXTRA_TITLE = false;

export const DISPLAY_DETAILS = false;

export const BORDER_COLOR = makeThemeColor(PRIMARY);

export const INNER_BORDER_COLOR = makeThemeColor(TERTIARY);

export const POSTER_OVERLAY = makeThemeColor(TERTIARY);

export const HIGHLIGHT_COLOR = makeThemeColor(QUATERNARY);

export const ICONS = {
  [ICON_POSITION.TOP_LEFT]: 2,
  [ICON_POSITION.TOP_RIGHT]: 4,
  [ICON_POSITION.BOTTOM_RIGHT]: 1,
};

export const ICONS_TYPES = {
  [ICON_POSITION.TOP_LEFT]: Icon,
  [ICON_POSITION.TOP_RIGHT]: Badge,
  [ICON_POSITION.BOTTOM_RIGHT]: Icon,
};

export const templates = {
  PosterS: 'PosterS',
  PosterM: 'PosterM',
  PosterL: 'PosterL',
};

export const ITEMS_BY_BREAKPOINTS = {
  [templates.PosterS]: {
    general: {
      [HD]: 3,
      [FULL_HD]: 5,
    },
    search: {
      [HD]: 4,
      [FULL_HD]: 4,
    },
  },
  [templates.PosterM]: {
    general: {
      [HD]: 2,
      [FULL_HD]: 4,
    },
    search: {
      [HD]: 3,
      [FULL_HD]: 3,
    },
  },
  [templates.PosterL]: {
    general: {
      [HD]: 2,
      [FULL_HD]: 3,
    },
    search: {
      [HD]: 2,
      [FULL_HD]: 2,
    },
  },
};
